import type {
  TaskSelectionAnswerOptionType,
  Question_InputType,
  FileUploadMetadataType_InputType,
  QuestionMetadataBase_OutputType,
  AttachmentResponseType,
  NumericInputMetadataType_InputType
} from '@shared/generated/';
import { ComponentTypeType } from '@shared/generated/';
import type { SourceUseAnswer } from '@shared/types/energyUse';

export const isTaskSelectionAnswerOptionType = (
  answerOptions: Question_InputType['answer_options']
): answerOptions is TaskSelectionAnswerOptionType[] => {
  if (answerOptions === null || answerOptions === undefined) {
    return false;
  }
  if (
    Array.isArray(answerOptions) &&
    answerOptions.length > 0 &&
    typeof answerOptions[0] === 'object' &&
    answerOptions[0] !== null &&
    'name' in answerOptions[0] &&
    'status' in answerOptions[0]
  ) {
    return true;
  } else {
    return false;
  }
};

export const isSourceUseAnswerType = (
  answer: unknown
): answer is SourceUseAnswer => {
  if (answer === null || answer === undefined || typeof answer !== 'object') {
    return false;
  }
  if ('electric' in answer && 'natural_gas' in answer && 'none' in answer) {
    return true;
  } else {
    return false;
  }
};

export const isFileUploadMetadataType = (
  metadata: Question_InputType['metadata']
): metadata is FileUploadMetadataType_InputType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return 'attachment_category' in metadata;
};

export const isNumericInputMetadataType = (
  metadata: Question_InputType['metadata']
): metadata is NumericInputMetadataType_InputType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return 'min_numeric_value' in metadata;
};

export const isFileUploadQuestion = (
  question: Question_InputType
): question is Question_InputType & { answer: AttachmentResponseType[] } => {
  return question.component === ComponentTypeType.FILE_UPLOAD;
};

export const isQuestionMetadataWithAiExtraction = (
  metadata: unknown
): metadata is QuestionMetadataBase_OutputType => {
  return (
    !!metadata && typeof metadata === 'object' && 'ai_extraction' in metadata
  );
};
